import ModalService from "../services/modal-service";
import EventEmitterService from "../services/event-emitter-service";
import UserDataService from "../services/user-data-service";
import {GlobalService} from "../services/global-service";

let singleton = Symbol();
let singletonEnforcer = Symbol();

class ServiceLocator {

	constructor(enforcer) {
		if (enforcer !== singletonEnforcer)
			throw "Instantiation failed: use ServiceLocator.getInstance() instead of new.";

		this.headerLoaded = null;
		this.courseLang = null;

		this.globalService = new GlobalService();
		this.modalService = new ModalService();
		this.eventEmitterService = new EventEmitterService();
		this.userDataService = new UserDataService();
	}

	static get instance() {
		if (!this[singleton])
			this[singleton] = new ServiceLocator(singletonEnforcer);
		return this[singleton];
	}

	static set instance(v) { throw "Can't change constant property!" }
}

export default ServiceLocator;